export const handelOpenModalMyWallet = () => ({
    type: 'OPEN_MODAL_MY_WALLET'
});
export const handelCloseModalMyWallet = () => ({
    type: 'CLOSE_MODAL_MY_WALLET'
});
export const actionChangeDataWallet = (transactions,total,total_rows,offset, carrot) => ({
    type: 'CHANGE_DATA_WALLET',transactions,total,total_rows,offset, carrot
});
export const actionChangeLoaderMyWallet = (loader) => ({
    type: 'CHANGE_LOADER_MODAL_WALLET',loader
});